// @flow

import * as api from '../../../api/api';

export default function addCustomAttributionLinks(data: object) {
    return api.post('/v5/marketplace/attributions', data);
}



// WEBPACK FOOTER //
// ./src/view/my-store/api/addCustomAttributionLinks.js